<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import ActivityMap from '../../activities/search/ActivityMap.vue'

    @Component({mixins: [ActivityMap]})
    export class ExtraServiceMap extends Vue {}

    export default {...toNative(ExtraServiceMap), ssrRender: ActivityMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }
</style>
